<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="套餐组名称：">
                <el-input v-model.trim="searchForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgGroupListPageHandle">搜索</el-button>
                <el-button type="primary" @click="showAddPkgGroup">新建组</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="name" label="套餐组名称"></el-table-column> 
            <el-table-column prop="saleName" label="活动名称"></el-table-column>  
       <el-table-column prop="isDownName" label="余额限制"></el-table-column>
            <el-table-column prop="isNextMonthName" label="跨月类型"></el-table-column>  
            <el-table-column prop="supplierTypeName" label="所属类别"></el-table-column> 
            <el-table-column prop="bindName" label="实名认证"></el-table-column> 
            <el-table-column prop="createTime" label="创建时间"></el-table-column> 
            <el-table-column prop="stateName" label="状态"></el-table-column> 
            <el-table-column prop="remark" label="备注"></el-table-column> 
            <el-table-column label="操作" width="300"> 
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="sharePkgGroup(scope.row)">购卡配置</el-button>
                     <el-button type="text" size="small" @click="sharePkgGroup1(scope.row)">活动图</el-button>
                       <el-button type="text" size="small" @click="sharePkgGroup11(scope.row)">商户号</el-button
          >
                    <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button>
                </template>    
            </el-table-column> 
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
                <el-form-item label="套餐组名称：" prop="name">
                    <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
                </el-form-item>    
                <el-form-item label="余额限制：" prop="isDown">
                      <el-select v-model="addOrEditGroupForm.isDown" placeholder="请选择">
                        <el-option v-for="item in pkgTypeOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item> 
                <el-form-item label="是否跨月：" prop="isNextMonth">
                      <el-select v-model="addOrEditGroupForm.isNextMonth" placeholder="请选择">
                        <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>   
                  <el-form-item label="活动类型：" prop="isPrice">
                      <el-select v-model="addOrEditGroupForm.isSale" placeholder="请选择">
                        <el-option v-for="item in isPriceOptions" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>  
                  <el-form-item label="实名认证：" prop="isBind">
                      <el-select v-model="addOrEditGroupForm.isBind" placeholder="请选择">
                        <el-option v-for="item in bindOpion" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属类别：" prop="supplierType">
                      <el-select v-model="addOrEditGroupForm.supplierType" placeholder="请选择">
                        <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>   
                 <el-form-item label="套餐组备注：" prop="remark">
                    <el-input v-model.trim="addOrEditGroupForm.remark" clearable></el-input>
                </el-form-item>  
                 <el-form-item label="余额购买参数：" prop="priceData">
                    <el-input v-model.trim="addOrEditGroupForm.priceData" placeholder="严谨按照参数规范填写 参数示列请点击下方按钮" clearable></el-input>
                </el-form-item>   
            </el-form>
            <div slot="footer" class="dialog-footer">
                  <el-button type="danger" @click="showYue">查询余额参数示列</el-button>
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtGroupHandle">确 定</el-button>
            </div>            
        </el-dialog>  


          <el-dialog :append-to-body="true"  title="余额参数示列" :visible.sync="shareImgs" width="700px" @close="cancel1" :close-on-click-modal="false">
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：最多只支持6个参数，amount代表充值金额/元 giftBalance表示赠送金额/元。请修改后完整输入此参数</div>
            <div style="text-align: center; width:100%;">               
                <p  alt="" style="margin: 0 auto;">{{urls}}</p>  
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="copy()" class="copy_url" :data-clipboard-text="urls">复制参数</el-button>
            </div>            
        </el-dialog>

        
     <el-dialog :append-to-body="true" class="formDialog"  :title="title" :visible.sync="shareGroup1" width="600px" @close="cancel12" :close-on-click-modal="false">
            <el-form ref="shareForm" :model="shareForm" label-width="120px">                
                  <el-form-item label="活动图(建议像素750*1392)：">
                    <input  type="file" ref="file2" placeholder="必选">
                    <img :src="getImgUrl() +  shareForm.priceImgUrl" alt="" width="150" height="150">  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel12">取 消</el-button>
                <el-button type="primary" @click="addOrEidtPkgHandle1">确 定</el-button>
            </div>            
        </el-dialog>

         <el-dialog
      :append-to-body="true"
      class="formDialog"
      :title="title"
      :visible.sync="shareGroup"
      width="600px"
      @close="cancel12"
      :close-on-click-modal="false"
    >
      <el-form ref="shareForm" :model="shareForm" label-width="120px">
        <el-form-item label="商品展示图(建议像素512*512)：">
          <input type="file" ref="file1" placeholder="必选" />
          <img
            :src="getImgUrl() + shareForm.shareImg"
            alt=""
            width="150"
            height="150"
          />
        </el-form-item>

        <el-form-item label="商品标题:" prop="shareName">
          <el-col :span="22">
            <el-input
              v-model.trim="shareForm.shareName"
              placeholder="必选"
              clearable
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品分类:" prop="shareType">
          <el-col :span="22">
            <el-input
              v-model.trim="shareForm.shareType"
              placeholder="必选"
              clearable
            ></el-input>
          </el-col>
        </el-form-item>

         <el-form-item label="商品价格/元:" prop="sharePrice">
          <el-col :span="22">
            <el-input
              v-model.trim="shareForm.sharePrice"
              placeholder="必选"
              clearable
            ></el-input>
          </el-col>
        </el-form-item>

         <el-form-item label="分代理商佣金/元:" prop="shareYongjing">
          <el-col :span="22">
            <el-input
              v-model.trim="shareForm.shareYongjing"
              clearable
            ></el-input>
          </el-col>
        </el-form-item>
        
        <el-form-item label="上下架状态：" prop="isShare">
          <el-radio-group v-model="shareForm.isShare">
            <el-radio :label="0">下架</el-radio>
            <el-radio :label="1">上架</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类排序:" prop="shareTypeOrderBy">
          <el-col :span="22">
            <el-input
              v-model.trim="shareForm.shareTypeOrderBy"
              placeholder="选填（数字越大排序越靠前）"
              clearable
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="商品排序:" prop="shareShopOrderBY">
          <el-col :span="22">
            <el-input
              v-model.trim="shareForm.shareShopOrderBY"
              placeholder="选填（数字越大排序越靠前）"
              clearable
            ></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle">确 定</el-button>
      </div>
    </el-dialog>




     <el-dialog
      :append-to-body="true"
      class="formDialog"
      :title="title"
      :visible.sync="shareGroup11"
      width="600px"
      @close="cancel12"
      :close-on-click-modal="false"
    >
      <el-form ref="shareForms" :model="shareForms" label-width="120px">
        <el-form-item label="商户类型：" prop="subType">
                    <el-radio-group v-model="shareForms.subType">
                        <el-radio label="20">微信支付</el-radio>
                        <el-radio label="50">乐刷支付</el-radio>
                        <!-- 
                        <el-radio label="30">财富通</el-radio> -->
                        <el-radio label="60">汇付支付</el-radio>
                    </el-radio-group>
                </el-form-item>

                  <el-form-item label="微信商户号:" prop="subId" v-if="shareForms.subType==20">
                    <el-col :span="22">
                        <el-input v-model.trim="shareForms.subId"  placeholder="商户号须和公众号进行绑定" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="微信商户密钥:" prop="subKey" v-if="shareForms.subType==20">
                    <el-col :span="22">
                        <el-input v-model.trim="shareForms.subKey"  placeholder="必选" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                

                 <el-form-item label="应用ID:" prop="subId" v-if="shareForms.subType==60">
                    <el-col :span="22">
                        <el-input v-model.trim="shareForms.subId"  placeholder="app_开头信息" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="应用密钥:" prop="subKey" v-if="shareForms.subType==60">
                    <el-col :span="22">
                        <el-input v-model.trim="shareForms.subKey"  placeholder="api_live_开头信息" clearable></el-input>
                    </el-col>                    
                </el-form-item>


                   <el-form-item label="商户号:" prop="subId" v-if="shareForms.subType==50">
                    <el-col :span="22">
                        <el-input v-model.trim="shareForms.subId"  placeholder="" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="支付密钥:" prop="subKey" v-if="shareForms.subType==50">
                    <el-col :span="22">
                        <el-input v-model.trim="shareForms.subKey"  placeholder="" clearable></el-input>
                    </el-col>                    
                </el-form-item>
                 <el-form-item label="回调密钥:" prop="subPwdKey" v-if="shareForms.subType==50">
                    <el-col :span="22">
                        <el-input v-model.trim="shareForms.subPwdKey"  placeholder="" clearable></el-input>
                    </el-col>                    
                </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle11"
          >确 定</el-button
        >
      </div>
    </el-dialog>


    
    </div>
</template>
<script>
import {getPkgGroupListPage,addPkgGroup,updatePkgGroup,changePkgGroupState, getPkgIsMonthOption} from '@/api/package.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
    data(){
        return {
              existBackImg:false,
            shareGroup:false,
               existBackImg1:false,
            shareGroup1:false,
            existBackImg:false,
            shareGroup:false,
              urls:'',
            shareImgs:false,
             shareForm: {
        id: "",
        name: "",
        subId: "",
        subKey: "",
        shareName: "",
        shareImg: "",
        priceImgUrl: "",
        isShare: "",

        shareType:'',
        shareYongjing:'',
        sharePrice:'',
        shareTypeOrderBy:'',
        shareShopOrderBY:'',
                
      },
            searchForm: {
                name: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,                
            },            
            addOrEditGroupForm: {
                name: '',
                type: '',
                isNextMonth: '',
                priceData:'',
                supplierType: '',
                remark:'',
                priceImgUrl:'',
                isSale:'',
                isBind:'',
                isDown:''
            },
            currentId: '',
            addFlag: null,
            addGroupVisibale: false,
            title: '',
            pkgTypeOption: [
                {
                    code:0,
                    description:'不限制'
                },
                 {
                    code:1,
                    description:'限制'
                }
            ],
             bindOpion:[
                {
                    code:0,
                    description:'无需认证'
                },
                 {
                    code:1,
                    description:'绑定手机号'
                },
 {
                    code:2,
                    description:'国政通认证'
                }
            ],
             isPriceOptions:[
                {
                    code:0,
                    description:'无活动'
                },
                 {
                    code:1,
                    description:'10元预存活动'
                },
                 {
                    code:2,
                    description:'20元预存活动'
                },
  {
                    code:3,
                    description:'80元送3+9活动'
                },
  {
                    code:4,
                    description:'60-80选择券活动'
                }
            ],
            supplierOption: [],
            isMonthOption: [],
            addOrEditGroupRules: {
                name: [{required: true, message: '请输入套餐名称', trigger: 'blur'}],
                type: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                isNextMonth: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                supplierType: [{required: true, message: '请选择套餐名称', trigger: 'change'}]
            },

            shareForms: {
        id: "",
        subId: "",
        subType:"",
        subKey: "",
        subPwdKey:""
      },
      shareGroup11:false,
        }
    },
    methods: {

       addOrEidtPkgHandle11() {
      
      common
        .sysRequest("pkg/group/update/sub/state", this.shareForms, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.shareGroup11 = false;
            this.getPkgGroupListPageHandle();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));
    },

       sharePkgGroup11(row) {
      this.shareForms.id = row.id;
      this.shareForms.subId = row.subId;
      this.shareForms.subKey = row.subKey;
      this.shareForms.subPwdKey = row.subPwdKey;
      this.shareForms.subType=row.subType;

      this.shareGroup11 = true;
    },



         addOrEidtPkgHandle() {
      let fd = new FormData();
      Object.keys(this.shareForm).forEach((key) => {
        fd.append(key, this.shareForm[key]);
      });
      fd.append("title", this.$refs.file1.files[0]);

      common
        .sysRequest("pkg/group/insert/share", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.getPkgGroupListPageHandle();
            this.$refs.file1.value = "";
            this.$message.success(res.data.message);
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
           sharePkgGroup(row) {

         this.shareForm.shareType = row.shareType;
         this.shareForm.sharePrice = row.sharePrice;
         this.shareForm.shareYongjing = row.shareYongjing;
          this.shareForm.shareTypeOrderBy = row.shareTypeOrderBy;
           this.shareForm.shareShopOrderBY = row.shareShopOrderBY;

      this.shareForm.id = row.id;
      this.shareForm.shareName = row.shareName;
      this.shareForm.shareImg = row.shareImg;
      this.shareForm.isShare = row.isShare;
      this.existBackImg = true;
      this.shareGroup = true;
    },
         cancel12(){
            this.shareGroup11=false;
            this.shareGroup=false;
            this.existBackImg1=false;
             this.shareGroup1=false;
            this.$refs.shareForm.resetFields();    
        }, 
          addOrEidtPkgHandle1(){
            let fd = new FormData();
            Object.keys(this.shareForm).forEach((key) => {
                        fd.append(key, this.shareForm[key]);
            })
             fd.append('title',this.$refs.file2.files[0]);

            common.sysRequest("pkg/group/insert/price/img", fd, 'post').then(res=>{
                            if(res.data.code == 200){
                                 this.$refs.file2.value='';
                                this.$message.success(res.data.message);
                                callback(res);
                            }else{
                                this.$message.error(res.data.message);
                            }
                        }).catch(err=> console.error(err));

             var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.shareGroup1 = false;
                    }else{                        
                        _this.$message.error(res.data.message)
                    }                     
                }
        },
          sharePkgGroup1(row){
           this.shareForm.id=row.id;
           this.shareForm.shareName=row.shareName;
           this.shareForm.priceImgUrl=row.priceImgUrl;
           this.existBackImg1=true;
           this.shareGroup1=true;
        },
        
            //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
              this.$message.success('复制成功');
              this.shareImgs=false;
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        showYue(){
            this.urls='[{"amount":25,"giftBalance":0},{"amount":35,"giftBalance":0.5},{"amount":50,"giftBalance":1},{"amount":100,"giftBalance":2},{"amount":200,"giftBalance":5},{"amount":500,"giftBalance":20}]'
            this.shareImgs=true;
        },
          cancel1(){
            this.shareImgs=false;
        },  
        cancel(){
            this.addGroupVisibale = false;      
            this.$refs.addOrEditGroupForm.resetFields();    
        },   
        showbtnText(state){
            return common.showTxtByState(state, {0: '启用', 1: '禁用'})
        },
        getPkgGroupListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getPkgGroupListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            }) 
        },
        showAddPkgGroup(){
            this.addGroupVisibale = true;
            this.addFlag = true;
            this.title = "新增套餐组";             
            this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
        },
        showEditPkgGroup(row){
            this.addGroupVisibale = true;
            this.addFlag = false;
            this.title = "修改套餐组";
            this.addOrEditGroupForm.priceData=row.priceData;
              this.addOrEditGroupForm.isBind=row.isBind;
            this.addOrEditGroupForm.name = row.name;
            this.addOrEditGroupForm.isDown = row.isDown;
            this.addOrEditGroupForm.type = row.type;
            this.addOrEditGroupForm.isSale = row.isSale;
            this.addOrEditGroupForm.remark=row.remark;
            this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
            this.addOrEditGroupForm.supplierType = row.supplierType;
            this.currentId = row.id; 
        },
        addOrEidtGroupHandle(){
            this.$refs.addOrEditGroupForm.validate(valid => {
                if(valid) {
                    var data = this.addOrEditGroupForm;
                    if(this.addFlag == true){
                        addPkgGroup(data).then(res => callback(res))
                    }else{
                        data.id = this.currentId
                        updatePkgGroup(data).then(res => callback(res))               
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgGroupListPageHandle();
                        _this.addGroupVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            }) 
        },
        changeStateHandle(id){
            var data = {
                id
            }
            changePkgGroupState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    this.getPkgGroupListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })           
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgGroupListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getPkgGroupListPageHandle();
        }  
    },
    created () {
        this.getPkgGroupListPageHandle();
        common.getSupplierOptionCom(this, 'supplierOption');
        getPkgIsMonthOption().then(res => {
            if(res.data.code == 200){
                this.isMonthOption = res.data.data;
            }else{
                this.$message.error(res.data.message);
            }            
        })
    }    
}
</script>
<style>

</style>
